import React from "react";
import styles from "../../PatientsIP/ReceptionistIp/BillingIp/BillingIp.module.css";
import { formatMoney } from "../common/money";

const PharmacyBillPaidCard = ({ bill }) => {
  const totalPaid = Number(bill?.paid_amount || 0);
  // Net of any approved returns, so the progress bar reflects what's actually still owed.
  const totalBill = Number(bill?.net_grand_total ?? bill?.grand_total ?? 0);
  const progress = totalBill > 0 ? Math.min((totalPaid / totalBill) * 100, 100) : 0;
  const marker25 = totalBill > 0 ? Math.round(totalBill * 0.25) : 0;
  const marker75 = totalBill > 0 ? Math.round(totalBill * 0.75) : 0;

  return (
    <section className={styles.paidCard}>
      <p className={styles.paidLabel}>Total amount paid</p>
      <p className={styles.paidAmount}>{formatMoney(totalPaid)}</p>
      <div className={styles.paidProgressBlock}>
        <div className={styles.progressTrack}>
          <div className={styles.progressFill} style={{ width: `${progress}%` }} />
        </div>
        <div className={styles.progressLabels}>
          <span>{formatMoney(marker25)}</span>
          <span>{formatMoney(marker75)}</span>
          <span className={styles.progressTotal}>Tot. {formatMoney(totalBill)}</span>
        </div>
      </div>
    </section>
  );
};

export default PharmacyBillPaidCard;
